import React, { useState } from 'react';
import { InputText, InputMoney, InputDate } from '../../Inputs';

/**
 * Refinance form for the commercial calculator.
 **/
const CommercialCalculatorRefinanceForm = ({ formProps }) => {
  return (
    <div className="grid">
      <div className="grid__col-xs-12">
        <InputText {...formProps} name="borrower" label="Borrower" />
      </div>
      <div className="grid__col-xs-12">
        <InputMoney
          {...formProps}
          name="newLoanAmount"
          label="New Loan Amount"
          required={true}
        />
      </div>
      <div className="grid__col-xs-12">
        <InputMoney
          {...formProps}
          name="balanceExistingLoan"
          label="Balance of Existing Loan"
          required={true}
        />
      </div>
      <div className="grid__col-xs-12">
        <InputDate
          {...formProps}
          name="originalDateLoan"
          label="Original Date of Existing Loan"
          required={true}
        />
      </div>
    </div>
  );
};

export default CommercialCalculatorRefinanceForm;
